/*
  Sleek homepage: prev/next arrows for the swipe rows ([data-hs-scroll]) and
  the review strip ([data-hs-rbar]): live five-star count plus a rotating
  short customer quote, both from Stamped. Every home-sleek section loads
  this file; the guard makes the second and later copies no-ops.
*/
(function () {
  if (window.__hsReady) return;
  window.__hsReady = true;

  function syncArrows(scope) {
    var row = scope.querySelector('[data-hs-row]');
    if (!row) return;
    var prev = scope.querySelector('[data-hs-prev]');
    var next = scope.querySelector('[data-hs-next]');
    var max = row.scrollWidth - row.clientWidth - 2;
    if (prev) prev.disabled = row.scrollLeft <= 2;
    if (next) next.disabled = row.scrollLeft >= max;
    var arrows = scope.querySelector('.hs-arrows');
    if (arrows) arrows.style.visibility = max <= 0 ? 'hidden' : '';
  }

  function initRow(scope) {
    var row = scope.querySelector('[data-hs-row]');
    if (!row || row.__hs) return;
    row.__hs = true;
    function step(dir) {
      var item = row.firstElementChild;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      var w = item ? item.getBoundingClientRect().width + gap : row.clientWidth;
      var per = Math.max(1, Math.floor((row.clientWidth + gap) / w));
      row.scrollBy({ left: dir * per * w, behavior: 'smooth' });
    }
    var prev = scope.querySelector('[data-hs-prev]');
    var next = scope.querySelector('[data-hs-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', function () { syncArrows(scope); }, { passive: true });
    window.addEventListener('resize', function () { syncArrows(scope); });
    syncArrows(scope);
  }

  // `total` is the five-star count (the widget's default filter, the same
  // number snippets/cpdp-stats.liquid shows); `totalAll` counts every rating
  // and must never be labelled five-star. Round down so the claim never
  // exceeds the real number.
  function fiveStarTotal(d) {
    var n = Number(d && d.total);
    if (!n) return '';
    if (n >= 1000) return (Math.floor(n / 100) * 100).toLocaleString('en-US') + '+';
    return n.toLocaleString('en-US');
  }

  // Short five-star quotes only: a review title, or failing that a short
  // message, that fits on one line. No source label (store rule).
  function pickQuotes(d) {
    var out = [];
    (d.data || []).forEach(function (r) {
      if (r.reviewRating !== 5) return;
      var text = (r.reviewTitle || '').trim();
      if (text.length < 12) text = (r.reviewMessage || '').trim();
      text = text.replace(/\s+/g, ' ').replace(/[.!]+$/, '');
      if (text.length < 12 || text.length > 70) return;
      text = text.charAt(0).toUpperCase() + text.slice(1);
      out.push({ text: text, author: (r.author || '').trim() });
    });
    return out;
  }

  function initReviewBar(bar) {
    if (bar.__hs) return;
    bar.__hs = true;
    var countEl = bar.querySelector('[data-hs-count]');
    var quoteEl = bar.querySelector('[data-hs-quote]');
    var suffix = bar.getAttribute('data-hs-suffix') || '';
    fetch(bar.getAttribute('data-hs-rbar'))
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) {
        var total = fiveStarTotal(d);
        if (total && countEl) countEl.textContent = total + ' ' + suffix;
        if (!quoteEl) return;
        var quotes = pickQuotes(d);
        if (!quotes.length) return;
        var i = 0;
        function show() {
          var q = quotes[i % quotes.length];
          quoteEl.innerHTML = '';
          var qq = document.createElement('q');
          qq.textContent = q.text;
          quoteEl.appendChild(qq);
          if (q.author) {
            var c = document.createElement('cite');
            c.textContent = '— ' + q.author;
            quoteEl.appendChild(c);
          }
        }
        show();
        if (quotes.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        setInterval(function () {
          quoteEl.classList.add('is-fading');
          setTimeout(function () { i++; show(); quoteEl.classList.remove('is-fading'); }, 350);
        }, 5000);
      })
      .catch(function () { /* the strip keeps its fallback text */ });
  }

  function initAll() {
    document.querySelectorAll('[data-hs-scroll]').forEach(initRow);
    document.querySelectorAll('[data-hs-rbar]').forEach(initReviewBar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Theme editor: re-run when a section is added or re-rendered
  document.addEventListener('shopify:section:load', initAll);
})();
